import React from 'react';
import PropTypes from 'prop-types';

import useFetchDevFeatureFlagQuery from 'App/hooks/useFetchDevFeatureFlagQuery';
import checkFeatureFlagStatus from 'App/components/FeatureFlags/checkFeatureFlagStatus';
import PageSpinner from 'App/components/PageSpinner';
import { NotFound } from '../errors';

function FeatureFlagRoute({ featureFlagName, children }) {
    const { data: flags, isLoading } = useFetchDevFeatureFlagQuery();

    if (isLoading) {
        return <PageSpinner />;
    }

    if (!checkFeatureFlagStatus({ flags, featureFlagName })) {
        return <NotFound />;
    }

    return children;
}

FeatureFlagRoute.propTypes = {
    featureFlagName: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};

export default FeatureFlagRoute;
